import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { DecisionSwal } from "Utils/Utils/DecisionSwal";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { HistorialSalidasApi } from "../api/HistorialSalidasApi";
import Paginacion from "../../../../../../Utils/Components/Paginacion/Paginacion";
import LoadMask from "../../../../../../Utils/LoadMask/LoadMask";
import { FiltrosSalidas } from "./FiltrosSalidas";
import { SalidasTable } from "./SalidasTable";
import { useDebounce } from "../../../../../../Utils/Hooks/useDebounce";
import {
    dateToDayEnd,
    dateToDayStart,
    getErrorFromResponse,
} from "../../../../../../../../utility/utils";

export const Listado = ({ storageKey }) => {
    const STORAGE_KEY = storageKey;
    const savedState = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    const filtros = savedState && savedState.filtros ? savedState.filtros : {};

    const fechaInicialDefault = filtros.fecha_inicial
        ? moment(filtros.fecha_inicial)
        : null;

    const fechaFinalDefault = filtros.fecha_final
        ? moment(filtros.fecha_final)
        : null;

    const { control, watch } = useForm({
        defaultValues: {
            fecha_inicial: fechaInicialDefault,
            fecha_final: fechaFinalDefault,
        },
    });

    const [salidas, setSalidas] = useState([]);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(
        savedState.pagina || 1,
    );
    const [cantidadResultados, setCantidadResultados] = useState(0);

    const fecha_inicial = watch("fecha_inicial");
    const fecha_final = watch("fecha_final");

    const {
        getSalidasBodega,
        validarReversionSalida,
        revertirSalida,
        cargando,
    } = HistorialSalidasApi();

    const GetSalidas = async () => {
        try {
            const params = {
                page: paginaSeleccionada,
            };

            if (fecha_inicial) {
                params.fecha_inicial = dateToDayStart(fecha_inicial);
            }

            if (fecha_final) {
                params.fecha_final = dateToDayEnd(fecha_final);
            }

            const response = await getSalidasBodega(params);
            setSalidas(response.results);
            setCantidadResultados(response.count);
        } catch (error) {
            // Si el error es por una página inválida, volvemos a la página anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener las salidas",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setSalidas([]);
            setCantidadResultados(0);
        }
    };

    const RevertirSalidaConfirmada = async (salida) => {
        try {
            await revertirSalida(salida.id);

            NotificationManager.success(
                `Salida ${salida.numero} revertida`,
                "Éxito",
                3000,
            );

            GetSalidas();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al revertir la salida",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    // La confirmación se pide solo si el servidor indica que la salida todavía
    // se puede revertir
    const RevertirSalida = async (salida) => {
        try {
            await validarReversionSalida(salida.id);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "No se puede revertir la salida",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            return;
        }

        DecisionSwal(
            `La salida ${salida.numero} se eliminará y su número no volverá ` +
                "a utilizarse. ¿Deseas continuar?",
            "Sí, revertir",
            "Cancelar",
            () => RevertirSalidaConfirmada(salida),
        );
    };

    useEffect(() => {
        GetSalidas();
    }, [paginaSeleccionada]);

    useEffect(() => {
        GetSalidas();
    }, [fecha_inicial, fecha_final]);

    useEffect(() => {
        const stateToSave = {
            filtros: {
                fecha_inicial,
                fecha_final,
            },
            pagina: paginaSeleccionada,
        };

        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
    }, [fecha_inicial, fecha_final, paginaSeleccionada]);

    return (
        <div className="ingresos-bodega__tab-wrapper">
            <LoadMask loading={cargando} blur>
                <CardEmpty noShadow>
                    <div className="ingresos-bodega__table-header">
                        <FiltrosSalidas
                            control={control}
                            onRefresh={() => {
                                GetSalidas();
                            }}
                            resetPage={() => setPaginaSeleccionada(1)}
                        />
                        <Link to={`/produccion-bodega/crear-salida`}>
                            <button className="btn btn-primary">
                                Crear Salida
                            </button>
                        </Link>
                    </div>

                    <SalidasTable
                        salidas={salidas}
                        onRevertir={RevertirSalida}
                    />
                    <Paginacion
                        cantidadResultados={cantidadResultados}
                        paginaSeleccionada={paginaSeleccionada}
                        setPaginaSeleccionada={setPaginaSeleccionada}
                    />
                </CardEmpty>
            </LoadMask>
        </div>
    );
};
